import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import {
  fetchData,
  fetchFormData,
  loanSegmentOptions,
} from "../../utils/options";
import topTost from "../../utils/topTost";

const Loan_TypeCreate = ({permission}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    loan_type_name: "",
    loan_segment: "",
    created_by: "",
    status: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchUserDetails = async (id) => {
    try {
      const result = await fetchData(`loan-type/${id}`, {}, "GET");

      if (result && result.data) {
        setFormData(result.data);
      } else {
        console.warn("User data not found.");
        setFormData("");
      }
    } catch (error) {
      console.error("Failed to fetch user details:", error);
      setFormData("");
    }
  };

  useEffect(() => {
    if (id) {
      fetchUserDetails(id);
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Construct FormData
      const form = new FormData();

      form.append("branchID", 1);
      form.append("loan_type_name", formData.loan_type_name);
      form.append("loan_segment", formData.loan_segment);
      form.append("created_by", userId);
      form.append("moduleId", M_id);

      let response;

      if (id) {
        form.append("id", id);
        form.append("userId", userId);
        // Edit existing user
        response = await fetchFormData("update-loan-types", form, "POST");
      } else {
        // Create new user
        response = await fetchFormData("add-loan-types", form, "POST");
      }

      if ((response && response.code === 200) || response.code === 201) {
        topTost({
          title: response?.message,
          icon: "success",
        });
        navigate(`/master/inquiry-type-list?id=${M_id}`);
      } else if (response && response.code === 422) {
        topTost({
          title: Array.isArray(response.message)
            ? response.message[{}]
            : response.message || "Validation error",
          icon: "error",
        });
      } else {
        topTost({
          title: response?.message || "Operation failed",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      topTost({
        title: "Unexpected error occurred",
        icon: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-5 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                <span className="d-block mb-2">
                  {id ? "Edit Inquiry Type:" : "Add Inquiry Type:"}
                </span>
              </h5>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Inquiry Type Name"
                    name="loan_type_name"
                    value={formData.loan_type_name}
                    onChange={handleChange}
                    placeholder="Inquiry Type Name"
                    icon="feather-file-text"
                    required
                  />
                </div>
                <div className="col-md-2 mt-2">
                  <label className="fw-semibold">Inquiry Segment:
                    <span className="text-danger py-2">*</span>
                  </label>
                </div>
                <div className="col-lg-4">
                  <SelectDropdown
                    options={loanSegmentOptions}
                    selectedOption={
                      loanSegmentOptions.find(
                        (opt) => opt.value === formData.loan_segment
                      ) || null
                    }
                    defaultSelect={"Select Segment"}
                    value={formData.loan_segment}
                    onSelectOption={(option) =>
                      handleChange("loan_segment", option.value)
                    }
                  />
                </div>
              </div>
              <div className="mt-5 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loan_TypeCreate;
